import { render } from "./SuccessStoriesView.vue?vue&type=template&id=7bb3b674"
import script from "./SuccessStoriesView.vue?vue&type=script&lang=js"
export * from "./SuccessStoriesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__